import { Avatar } from "../design/avatar";
import { Button } from "../design/button";
import { Heading, Subheading } from "../design/heading";
import { useAuth } from "../contexts/AuthContext";
import { sendEmailVerification, signOut } from "firebase/auth";
import { useState } from "react";
import { Text } from "../design/text";
import { auth } from "../firebase";
import LogoHorizontal from "./LogoHorizontal";
import { useTenant } from "../contexts/TenantContext";
import { PoweredByLogo } from "./PoweredByLogo";

const VerifyEmailView: React.FC = () => {
  const { tenant } = useTenant();
  const { user } = useAuth();
  const [state, setState] = useState<"emailSent" | "emailNotSent">(
    "emailNotSent",
  );

  const handleVerifyEmail = async () => {
    if (!user) {
      return;
    }
    await sendEmailVerification(user);
    setState("emailSent");
  };

  const handleRefreshView = async () => {
    await user?.getIdToken(true);
    window.location.reload();
  };

  const handleLogout = async () => {
    if (!user) {
      return;
    }
    await signOut(auth);
  };

  return (
    <>
      <div className="absolute flex items-center justify-between w-full max-w-screen-md p-4">
        <Text
          onClick={handleLogout}
          className="cursor-pointer text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-300"
        >
          Logout
        </Text>
      </div>
      <div className="flex flex-col items-center justify-center min-h-screen">
        <div className="w-full max-w-lg p-6 text-center bg-white rounded-lg shadow-lg dark:bg-gray-800">
          <LogoHorizontal
            tenant={tenant}
            className="items-center h-10 mx-auto"
          />
          <Heading>Please Verify Your Email</Heading>
          <Subheading>
            You will need to verify your email to finalize your account.
          </Subheading>
          <Text>
            If you've already verified your email, please refresh the page.
          </Text>
          {state === "emailSent" && (
            <div className="space-x-2 text-center">
              <Text>
                A verification email has been sent to your email address. Please
                check your inbox.
              </Text>
              <Text>If you don't see it, please check your spam folder.</Text>
              <div className="space-x-2">
                <Button
                  className="mt-4"
                  onClick={handleRefreshView}
                  disabled={!user}
                >
                  Refresh
                </Button>
                <Button plain className="mt-4" href="mailto:info@casetime.com">
                  Contact Support
                </Button>
              </div>
            </div>
          )}
          {state === "emailNotSent" && (
            <div className="space-x-2 text-center">
              <Button
                className="mt-4"
                onClick={handleVerifyEmail}
                disabled={!user}
              >
                Send Verification Email
              </Button>
              <Button plain href="mailto:info@casetime.com">
                Contact Support
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VerifyEmailView;
